// Suivi des campagnes publicitaires (Pixel Meta) et de la source des visites (UTM).
// Le pixel ne se charge que si le visiteur accepte les cookies publicitaires
// (voir components/MetaPixel.jsx). Les événements envoyés avant le chargement sont ignorés.

const UTM_KEY = "mboa_utm";
const UTM_FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "ttclid", "gclid"];
const UTM_DAYS = 30;

// Sans lien suivi, la source est déduite du site d'origine quand le navigateur le donne.
// Les applications (TikTok, WhatsApp…) le masquent souvent : ces visites restent « direct / inconnu ».
const REFERRER_SOURCES = [ // [source, mots contenus dans l'adresse, adresses exactes]
    ["tiktok", ["tiktok", "musically"], []],
    ["facebook", ["facebook", "messenger"], ["fb.com", "fb.me"]],
    ["instagram", ["instagram"], []],
    ["youtube", ["youtube"], ["youtu.be"]],
    ["whatsapp", ["whatsapp"], ["wa.me"]],
    ["telegram", ["telegram"], ["t.me"]],
    ["x", ["twitter"], ["x.com", "t.co"]],
    ["linkedin", ["linkedin"], ["lnkd.in"]],
    ["google", ["google"], []],
    ["bing", [], ["bing.com"]],
];
const REFERRER_IGNORED = ["chariow", "moneroo", "stripe", "paypal"]; // retour de paiement : pas une source

/** Source déduite du site d'origine : { source, known } ou null (site interne, paiement, aucun). */
function sourceFromReferrer() {
    try {
        if (!document.referrer) return null;
        const host = new URL(document.referrer).hostname.toLowerCase().replace(/^www\./, "");
        if (!host || host === window.location.hostname.replace(/^www\./, "")) return null;
        if (REFERRER_IGNORED.some((x) => host.includes(x))) return null;
        const hit = REFERRER_SOURCES.find(([, words, hosts]) => words.some((w) => host.includes(w)) || hosts.some((h) => host === h || host.endsWith(`.${h}`)));
        return hit ? { source: hit[0], known: true } : { source: host, known: false };
    } catch { return null; }
}

let referrerChecked = false; // document.referrer ne change pas pendant la navigation interne

/** Mémorise la source d'arrivée (ex. ?utm_source=facebook&utm_campaign=talent_s1), 30 jours. */
export function captureUtm() {
    try {
        const p = new URLSearchParams(window.location.search);
        const found = {};
        UTM_FIELDS.forEach((k) => { if (p.get(k)) found[k] = p.get(k).slice(0, 120); });
        const firstCheck = !referrerChecked;
        referrerChecked = true;
        if (Object.keys(found).length) {
            localStorage.setItem(UTM_KEY, JSON.stringify({ ...found, ts: Date.now() }));
        } else if (firstCheck) {
            const ref = sourceFromReferrer();
            // Un réseau connu remplace l'ancienne source ; un site inconnu ne remplit qu'une source vide.
            if (ref && (ref.known || !getUtm())) {
                localStorage.setItem(UTM_KEY, JSON.stringify({ utm_source: ref.source.slice(0, 120), utm_medium: "referral", ts: Date.now() }));
            }
        }
    } catch { /* stockage indisponible */ }
}

/** Source mémorisée, envoyée avec l'inscription et la candidature (ou null). */
export function getUtm() {
    try {
        const v = JSON.parse(localStorage.getItem(UTM_KEY) || "null");
        if (!v || Date.now() - (v.ts || 0) > UTM_DAYS * 86400000) return null;
        const { ts, ...rest } = v;
        return rest;
    } catch { return null; }
}

/** Événement Meta (standard : ViewContent, Lead, CompleteRegistration, SubmitApplication…). */
export function track(event, params = {}) {
    try { if (typeof window.fbq === "function") window.fbq("track", event, params); } catch { /* pixel absent */ }
}
